import { render, staticRenderFns } from "./dataWindow.vue?vue&type=template&id=3ba088d5&scoped=true"
import script from "./dataWindow.vue?vue&type=script&lang=js"
export * from "./dataWindow.vue?vue&type=script&lang=js"
import style0 from "./dataWindow.vue?vue&type=style&index=0&id=3ba088d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba088d5",
  null
  
)

export default component.exports